<div class="desktop-full-screen-overlay--flex voucher-return-value-dialog">
  <div>
    <app-form-container
      [title]="'webPos.Voucher.VoucherValueDialogTitle' | translate"
      (onCancel)="onCancel()"
      (onSubmit)="onConfirm()"
      [confirmDisabled]="form.invalid">
      <ng-container form-body [formGroup]="form">
        <div class="voucher-return-value-dialog__row">
          <app-dropdown
            class="voucher-return-value-dialog__field"
            [label]="'webPos.Voucher.VoucherType' | translate"
            [options]="typeOptions"
            formControlName="voucherType">
          </app-dropdown>
        </div>

        @if (form.controls.voucherType.value !== null) {
          <div class="voucher-return-value-dialog__row">
            <app-form-input
              class="voucher-return-value-dialog__field"
              [label]="'webPos.Voucher.VoucherValue' | translate"
              [type]="FormInputType.Number"
              formControlName="amount">
            </app-form-input>
          </div>
          <div class="voucher-return-value-dialog__hint">
            {{ 'webPos.MaxAllowedAmount' | translate }}: {{ maxForSelectedType | hcurrency }}
          </div>
          @if (form.controls.amount.touched && form.controls.amount.errors?.['max']) {
            <div class="voucher-return-value-dialog__error">
              {{ 'webPos.Voucher.AmountExceedsMax' | translate }}
            </div>
          }
        }
      </ng-container>
    </app-form-container>
  </div>
</div>
